import { Component, OnInit } from '@angular/core';
import { AnreService } from '../service/anre.service';
import { Notification } from '../../account/models/Notification';
import { Page } from '../../../shared/model/page';
import { NotificationFilterForm } from './models/NotificationFilterForm';

@Component({
  selector: 'app-notifications-anre',
  templateUrl: './notifications-anre.component.html',
  styleUrls: ['./notifications-anre.component.scss']
})
export class NotificationsAnreComponent implements OnInit {

  public notifications: Page<Notification>;
  public paginationNotifications = [];
  public notificationFilterForm: NotificationFilterForm = new NotificationFilterForm();
  public notificationDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'viewNotificationDetails',
          title: '<p>Vezi detalii</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    hideSubHeader: true,
    columns: {
      authorName: {
        title: 'Nume de cod emițător'
      },
      description: {
        title: 'Descriere mesaj'
      },
      author: {
        title: 'Emițător mesaj',
        valuePrepareFunction: (author) => {
          return author ? author.name : '';
        }
      },
      correlation: {
        title: 'Corelație',
        valuePrepareFunction: (correlation) => {
          return correlation ? correlation.name : '';
        }
      },
      message: {
        title: 'Mesaj',
        valuePrepareFunction: (message) => {
          return message ? message.name : '';
        }
      },
      date: {
        title: 'Data',
        valuePrepareFunction: (value) => {
          return value ? new Date(value).toLocaleDateString('ro-RO') : '';
        }
      },
      read: {
        title: 'Status',
        valuePrepareFunction: (value) => {
          return value ? 'Citită' : 'Necitită';
        }
      }
    },
  };

  constructor(
    private anreService: AnreService
  ) { }

  ngOnInit(): void {
    this.searchNotifications();
  }

  onCustomActionNotifications(event: any): void {
    console.log(event);
  }

  searchNotifications(): void {
    this.anreService.getAnreNotifications(this.notificationFilterForm).subscribe((notifications) => {
      this.notifications = notifications;
      this.notificationFilterForm.pageOffset = notifications.number;
      this.paginationNotifications = [{ pageNumber: notifications.number, className: 'page-item active' }];
    });
  }

  changePage(page: any): void {
    this.notificationFilterForm.pageOffset = page.pageNumber;
    this.searchNotifications();
  }

  previousPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === 0 ? 0 : this.notificationFilterForm.pageOffset - 1;
    this.searchNotifications();
  }

  nextPage(): void {
    this.notificationFilterForm.pageOffset = this.notificationFilterForm.pageOffset === this.notifications.totalPages - 1
      ? this.notificationFilterForm.pageOffset : this.notificationFilterForm.pageOffset + 1;
    this.searchNotifications();
  }

}
